import { render, staticRenderFns } from "./matching-card-compact-placeholder.vue?vue&type=template&id=41edcc12&scoped=true&"
import script from "./matching-card-compact-placeholder.vue?vue&type=script&lang=ts&"
export * from "./matching-card-compact-placeholder.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card-compact-placeholder.vue?vue&type=style&index=0&id=41edcc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41edcc12",
  null
  
)

export default component.exports